import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';
import { useSelector, useDispatch } from 'react-redux';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import FindMultyStudentPopup from "@/pages/comp/basic/student/popup/find_multy";
import ClassSupplyDataFunc from "@/pcomponents/common/content/trade/supply/func/data_func";
import Style from './css/style.module.css';
import StuArea from './area/stu_area';
import WriteSupplyArea from "./area/write_supply";

function AddCustomSupplyArea(props: any) {
  let myProps = {
    stu_seq_arr: [],
    supply_row_data: {},
    refresh_data: (inData: any) => { },
    is_show_close: true,
    close_text: "닫기",
    close: () => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  let now_ymd = DateFunc.get_date_format(new Date(), "Ymd");
  let now_y_m_d = DateFunc.get_date_format(new Date(), "Y-m-d");
  let default_supply_row_data = {
    ...ClassSupplyDataFunc.default_info_data,
    a_ymd: now_ymd,
    a_sort: "etc",
    a_date: now_y_m_d,
    a_stu_seq: "",
    a_stu_name: "",
    a_responser_seq: user.user_seq,
    a_responser_name: user.user_name,
    a_title: "기타청구 " + now_y_m_d,
    a_money: "",
    a_discount_money: "",
    a_pay_money: "",
    a_point_money: "",
    a_money_sum: "",
    a_memo: "",
    ...myProps.supply_row_data
  };
  let [supply_row_data, set_supply_row_data] = useState(default_supply_row_data);
  let [stu_info_arr, set_stu_info_arr] = useState<any>([]);

  const [popupData, setPopupData] = useState({
    isOpen: false,
    sort: "find",//view
    has_header: true,
    title: "팝업",
    s_except_user_seq:[],
    width: "800px",
    height: "80%",
  });

  useEffect(() => {
    get_stu_info_arr_by_ajax({ stu_seq_arr: myProps.stu_seq_arr });
  }, []);

  const get_stu_info_arr_by_ajax = (inData: any) => {
    let opt_obj = {
      stu_seq_arr: [],
      ...inData
    };
    if (strFunc.is_empty(opt_obj.stu_seq_arr)) {
      //alert("학생 키가 없습니다.");
      return false;
    }
    let form_json_data = {
      "s_seq": opt_obj.stu_seq_arr,
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_stu_info_arr(response.data["data"]["info_arr"]);
        } else {
          set_stu_info_arr([]);
        }
      });
  };

  const go_write_supply_by_ajax = () => {
    if (stu_info_arr.length == 0) {
      alert("학생을 선택해주세요.");
      return false;
    }
    if (strFunc.is_empty(supply_row_data["a_money_sum"])) {
      alert("청구금액이 없습니다.");
      return false;
    }
    if (strFunc.is_empty(supply_row_data["a_title"])) {
      alert("제목이 없습니다.");
      return false;
    }
    if (confirm("청구서를 생성하시겠습니까?") == false) {
      return false;
    }
    let add_supply_arr = [];
    for (let i = 0; i < stu_info_arr.length; i++) {
      let stu_info = stu_info_arr[i];
      let add_supply_row_data = {
        ...supply_row_data,
        a_stu_seq: stu_info["a_seq"],
        a_stu_name: stu_info["a_user_name"],
      };
      add_supply_arr.push(add_supply_row_data);
    }
    let form_json_data = {
      "data_arr": add_supply_arr,
      "is_default_val": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/class_supply/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          myProps.refresh_data({});
          myProps.close();
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const open_find_stu_popup = () => {
    let pop_title = "학생찾기";
    let s_except_user_seq:any = [];
    for (let i = 0; i < stu_info_arr.length; i++) {
      s_except_user_seq.push(stu_info_arr[i]["a_seq"]);
    }
    setPopupData({
      ...popupData,
      "isOpen": true,
      "title": pop_title,
      s_except_user_seq:s_except_user_seq,
      "sort": "find",
      width: "800px",
      height: "80%",
    });
  };

  const callBackDataStuPopup = (inData: any) => {
    let optObj = {
      info_arr: [],
      row_num: 0,
      key: "",
      ...inData,
    };
    if (optObj["info_arr"].length > 0) {
      let exist_stu_seq_arr: any = [];
      for (let i = 0; i < stu_info_arr.length; i++) {
        exist_stu_seq_arr.push(stu_info_arr[i]["a_seq"]);
      }
      let add_stu_info_arr = [];
      for (let i = 0; i < optObj["info_arr"].length; i++) {
        let stu_info: any = optObj["info_arr"][i];
        if (strFunc.str_in_array(stu_info["a_seq"], exist_stu_seq_arr) == -1) {
          add_stu_info_arr.push(stu_info);
        }
      }
      if (add_stu_info_arr.length > 0) {
        set_stu_info_arr([
          ...stu_info_arr,
          ...add_stu_info_arr
        ]);
      }
    }
  };

  return (
    <div>
      <h3>
        학생선택
        <button className="btn btn-dark ml-1"
          onClick={() => {
            open_find_stu_popup();
          }}>학생찾기</button>
      </h3>
      <StuArea
        stu_info_arr={stu_info_arr}
        set_stu_info_arr={set_stu_info_arr}
        Style={Style}
      ></StuArea>
      <div className="mt-1">
        <WriteSupplyArea
          supply_row_data={supply_row_data}
          set_supply_row_data={set_supply_row_data}
          Style={Style}
        ></WriteSupplyArea>
      </div>
      <div className="text-center mt-1">
        <button className="btn btn-sky" onClick={() => { go_write_supply_by_ajax(); }}>청구서 생성</button>
        {myProps.is_show_close &&
          <button className="btn btn-dark ml-1" onClick={() => { myProps.close(); }} >{myProps.close_text}</button>
        }
      </div>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} has_header={popupData.has_header} >
          {popupData.sort === "find" &&
            <FindMultyStudentPopup
              callBackData={callBackDataStuPopup}
              listOpt={{
                s_except_user_seq:popupData.s_except_user_seq
              }}
              is_multi_select_by_click={true}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></FindMultyStudentPopup>
          }
        </LayerPopup>
      }
    </div>
  );
};
export default AddCustomSupplyArea;